import _taggedTemplateLiteral from "/codebuild/output/src223969145/src/jackrobinsonmedia/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
import _defineProperty from "/codebuild/output/src223969145/src/jackrobinsonmedia/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/codebuild/output/src223969145/src/jackrobinsonmedia/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _assertThisInitialized from "/codebuild/output/src223969145/src/jackrobinsonmedia/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/codebuild/output/src223969145/src/jackrobinsonmedia/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/codebuild/output/src223969145/src/jackrobinsonmedia/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/codebuild/output/src223969145/src/jackrobinsonmedia/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import _decorate from "@babel/runtime/helpers/esm/decorate";

var _ = function _(t) {
  return t;
},
    _t,
    _t2,
    _t3,
    _t4,
    _t5,
    _t6,
    _t7,
    _t8;
/**
 * @license
 *
 * Copyright IBM Corp. 2020, 2021
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */


import { customElement, html, svg, property, LitElement } from 'lit-element';
import { classMap } from 'lit-html/directives/class-map';
import settings from 'carbon-components/es/globals/js/settings';
import ddsSettings from '@carbon/ibmdotcom-utilities/es/utilities/settings/settings.js';
import { LEADSPACE_TYPE, LEADSPACE_GRADIENT_STYLE_SCHEME, LEADSPACE_SIZE } from "./defs.js";
import styles from "./leadspace.css.js";
import StableSelectorMixin from "../../globals/mixins/stable-selector.js";
export { LEADSPACE_TYPE, LEADSPACE_GRADIENT_STYLE_SCHEME, LEADSPACE_SIZE };
var prefix = settings.prefix;
var ddsPrefix = ddsSettings.stablePrefix;
/**
 * The LeadSpace component.
 *
 * @element dds-leadspace
 * @slot action The action (CTA) content.
 * @slot image The image content.
 * @csspart section The first DOM node inside the shadow-root
 */

var DDSLeadSpace = _decorate([customElement("".concat(ddsPrefix, "-leadspace"))], function (_initialize, _StableSelectorMixin) {
  var DDSLeadSpace = /*#__PURE__*/function (_StableSelectorMixin2) {
    _inherits(DDSLeadSpace, _StableSelectorMixin2);

    var _super = _createSuper(DDSLeadSpace);

    function DDSLeadSpace() {
      var _this;

      _classCallCheck(this, DDSLeadSpace);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _super.call.apply(_super, [this].concat(args));

      _initialize(_assertThisInitialized(_this));

      return _this;
    }

    return DDSLeadSpace;
  }(_StableSelectorMixin);

  return {
    F: DDSLeadSpace,
    d: [{
      kind: "method",
      key: "_handleSlotChange",
      value:
      /**
       * Handler for @slotchange, ensure that the only element being rendered is DDSTagGroup
       *
       * @private
       */
      function _handleSlotChange(event) {
        var _this2 = this;

        var childItems = event.target.assignedNodes();
        childItems.filter(function (elem) {
          return elem.matches !== undefined ? elem.matches(_this2.constructor.tagGroupSelector) || elem.matches(_this2.constructor.breadcrumbSelector) : false;
        });
      }
      /**
       * Sets background image for leadspace centered
       */

    }, {
      kind: "method",
      key: "_getBackgroundImage",
      value: function _getBackgroundImage() {
        return this.defaultSrc && this.type === LEADSPACE_TYPE.CENTERED ? "background-image: url(".concat(this.defaultSrc, ")") : '';
      }
      /**
       * Returns a class-name based on the gradient parameter type
       */

    }, {
      kind: "method",
      key: "_getGradientClass",
      value: function _getGradientClass() {
        var _classMap;

        return classMap((_classMap = {}, _defineProperty(_classMap, "".concat(prefix, "--leadspace--gradient"), this.gradientStyleScheme === LEADSPACE_GRADIENT_STYLE_SCHEME.WITH_GRADIENT), _defineProperty(_classMap, "".concat(prefix, "--leadspace__overlay"), true), _classMap));
      }
      /**
       * Returns a class-name based on the type parameter type
       */

    }, {
      kind: "method",
      key: "_getTypeClass",
      value: function _getTypeClass() {
        var _classMap2;

        return classMap((_classMap2 = {}, _defineProperty(_classMap2, "".concat(prefix, "--leadspace--centered"), this.type === LEADSPACE_TYPE.CENTERED), _defineProperty(_classMap2, "".concat(prefix, "--leadspace--centered__image"), this.type === LEADSPACE_TYPE.CENTERED && this.defaultSrc), _defineProperty(_classMap2, "".concat(prefix, "--leadspace--productive"), this.type === LEADSPACE_TYPE.SMALL), _defineProperty(_classMap2, "".concat(prefix, "--leadspace__section"), true), _classMap2));
      }
      /**
       * Returns a class-name based on the size parameter type
       */

    }, {
      kind: "method",
      key: "_getContainerClass",
      value: function _getContainerClass() {
        var _classMap3;

        return classMap((_classMap3 = {}, _defineProperty(_classMap3, "".concat(prefix, "--leadspace__container--super"), this.size === LEADSPACE_SIZE.SUPER), _defineProperty(_classMap3, "".concat(prefix, "--leadspace__container--medium"), this.size === LEADSPACE_SIZE.MEDIUM), _defineProperty(_classMap3, "".concat(prefix, "--leadspace__container"), this.size === LEADSPACE_SIZE.NONE || this.size === LEADSPACE_SIZE.TALL), _classMap3));
      }
      /**
       * Renders Leadspace copy/description
       */

    }, {
      kind: "method",
      key: "_renderCopy",
      value: function _renderCopy() {
        var copy = this.copy;
        return html(_t || (_t = _(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n      <div class=\"", "--leadspace__row\">\n        <p data-autoid=\"", "--leadspace__desc\" class=\"", "\">\n          <slot>", "</slot>\n        </p>\n      </div>\n    "])), 0, 0, 0, 0)), prefix, ddsPrefix, this._getCopyType(), copy);
      }
      /**
       * Returns a class-name based on the size parameter type
       */

    }, {
      kind: "method",
      key: "_getCopyType",
      value: function _getCopyType() {
        var _classMap4;

        return classMap((_classMap4 = {}, _defineProperty(_classMap4, "".concat(prefix, "--leadspace__desc--super"), this.size === LEADSPACE_SIZE.SUPER), _defineProperty(_classMap4, "".concat(prefix, "--leadspace__desc--medium"), this.size === LEADSPACE_SIZE.MEDIUM), _defineProperty(_classMap4, "".concat(prefix, "--leadspace__desc"), this.size === LEADSPACE_SIZE.NONE || this.size === LEADSPACE_SIZE.TALL), _classMap4));
      }
      /**
       * Returns a class-name based on the size parameter type
       */

    }, {
      kind: "method",
      key: "_getContentType",
      value: function _getContentType() {
        var _classMap5;

        return classMap((_classMap5 = {}, _defineProperty(_classMap5, "".concat(prefix, "--leadspace--content__container"), this.size === LEADSPACE_SIZE.NONE || this.size === LEADSPACE_SIZE.TALL), _defineProperty(_classMap5, "".concat(prefix, "--leadspace--content__container--medium"), this.size === LEADSPACE_SIZE.MEDIUM), _defineProperty(_classMap5, "".concat(prefix, "--leadspace--content__container--super"), this.size === LEADSPACE_SIZE.SUPER), _classMap5));
      }
      /**
       * Renders Leadspace title slot
       */

    }, {
      kind: "method",
      key: "_renderHeading",
      value: function _renderHeading() {
        var title = this.title;
        return html(_t2 || (_t2 = _(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n      <slot name=\"heading\">", "</slot>\n    "])), 0)), title);
      }
      /**
       *  Renders the image slot or the mobile image for centered leadspace
       */

    }, {
      kind: "method",
      key: "_renderImage",
      value: function _renderImage() {
        var defaultSrc = this.defaultSrc,
            alt = this.alt,
            type = this.type;

        if (this.defaultSrc && type === LEADSPACE_TYPE.CENTERED) {
          return html(_t3 || (_t3 = _(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n        <div data-autoid=\"", "--leadspace--centered--mobile__image\" class=\"", "--leadspace--centered--mobile__image\">\n          <img src=\"", "\" alt=\"", "\" loading=\"lazy\" />\n        </div>\n      "])), 0, 0, 0, 0)), ddsPrefix, prefix, defaultSrc, alt);
        }

        return html(_t4 || (_t4 = _(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n      <slot name=\"image\"></slot>\n    "])))));
      }
      /**
       * The alternate text.
       */

    }, {
      kind: "field",
      decorators: [property()],
      key: "alt",
      value: function value() {
        return '';
      }
    }, {
      kind: "field",
      decorators: [property({
        attribute: 'default-src'
      })],
      key: "defaultSrc",
      value: function value() {
        return '';
      }
    }, {
      kind: "field",
      decorators: [property()],
      key: "copy",
      value: function value() {
        return '';
      }
    }, {
      kind: "field",
      decorators: [property({
        reflect: true,
        attribute: 'gradient-style-scheme'
      })],
      key: "gradientStyleScheme",
      value: function value() {
        return LEADSPACE_GRADIENT_STYLE_SCHEME.WITH_GRADIENT;
      }
    }, {
      kind: "field",
      decorators: [property()],
      key: "title",
      value: function value() {
        return '';
      }
    }, {
      kind: "field",
      decorators: [property({
        reflect: true
      })],
      key: "type",
      value: function value() {
        return LEADSPACE_TYPE.LEFT;
      }
    }, {
      kind: "field",
      decorators: [property({
        reflect: true
      })],
      key: "size",
      value: function value() {
        return 'tall';
      }
    }, {
      kind: "method",
      key: "render",
      value:
      /**
       * The image source.
       */

      /**
       * The leadspace copy.
       */

      /**
       * The gradient style sceheme.
       */

      /**
       * The leadspace title.
       */

      /**
       *  Leadspace type (small, left, or centered)
       */

      /**
       *  Leadspace size (super, tall, or medium)
       */
      function render() {
        var gradientStyleScheme = this.gradientStyleScheme,
            type = this.type;
        return html(_t5 || (_t5 = _(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n      <section style=\"", "\" class=\"", "\" part=\"section\">\n        <div class=\"", "\">\n          <div class=\"", "\">\n            ", "\n            <div class=\"", "\">\n              <div class=\"", "--leadspace__row\">\n                <slot name=\"navigation\" @slotchange=\"", "\"></slot>\n                ", "\n              </div>\n              <div class=\"", "--leadspace__content\">\n                ", "\n                <slot name=\"action\"></slot>\n              </div>\n            </div>\n          </div>\n          ", "\n        </div>\n      </section>\n    "])), 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0)), this._getBackgroundImage(), this._getTypeClass(), this._getContainerClass(), this._getGradientClass(), gradientStyleScheme === LEADSPACE_GRADIENT_STYLE_SCHEME.NONE ? undefined : svg(_t6 || (_t6 = _(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n                <svg\n                  class=\"", "--leadspace__gradient\"\n                  viewBox=\"0 0 100 100\"\n                  preserveAspectRatio=\"none\"\n                  xmlns=\"http://www.w3.org/2000/svg\"\n                  xmlns:xlink=\"http://www.w3.org/1999/xlink\"\n                >\n                  <defs>\n                    <linearGradient id=\"stops\" class=\"", "--leadspace__gradient__stops\">\n                      ", "\n                    </linearGradient>\n                  </defs>\n                  <rect class=\"", "--leadspace__gradient__rect\" width=\"100\" height=\"100\" />\n                </svg>\n              "])), 0, 0, 0, 0)), prefix, prefix, type === LEADSPACE_TYPE.CENTERED ? svg(_t7 || (_t7 = _(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n                          <stop offset=\"0%\" />\n                          <stop offset=\"27%\" />\n                          <stop offset=\"53%\" />\n                          <stop offset=\"80%\" />\n                        "]))))) : svg(_t8 || (_t8 = _(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n                          <stop offset=\"0%\" />\n                          <stop offset=\"25%\" />\n                          <stop offset=\"50%\" />\n                          <stop offset=\"75%\" />\n                        "]))))), prefix), this._getContentType(), prefix, this._handleSlotChange, this._renderHeading(), prefix, this._renderCopy(), this._renderImage());
      }
    }, {
      kind: "get",
      static: true,
      key: "breadcrumbSelector",
      value: function breadcrumbSelector() {
        return "".concat(prefix, "-breadcrumb");
      }
    }, {
      kind: "get",
      static: true,
      key: "headingSelector",
      value: function headingSelector() {
        return "".concat(ddsPrefix, "-leadspace-heading");
      }
    }, {
      kind: "get",
      static: true,
      key: "stableSelector",
      value: function stableSelector() {
        return "".concat(ddsPrefix, "--leadspace");
      }
    }, {
      kind: "get",
      static: true,
      key: "tagGroupSelector",
      value: function tagGroupSelector() {
        return "".concat(ddsPrefix, "-tag-group");
      }
    }, {
      kind: "field",
      static: true,
      key: "styles",
      value: function value() {
        return styles;
      }
    }]
  };
}, StableSelectorMixin(LitElement));

export default DDSLeadSpace;